// src/context/NotificationContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { getClientData } from "../components/custom";
import { useAuth } from "../context/AuthContext";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        if (!isAuthenticated) return;

        let lastShown = 0;
        const REMIND_INTERVAL = 15 * 60 * 1000;

        // Re-read the flag from localStorage on an interval so the popup shows
        // when the cron flips is_balance_notified to 1 *after* login (userService
        // keeps user_data fresh). Re-remind at most once every 15 minutes.
        const checkBalanceNotified = () => {
            const userData = getClientData();
            const isBalanceNotified = userData?.is_balance_notified;
            const inLoss = isBalanceNotified === "1" || isBalanceNotified === 1;
            const now = Date.now();

            if (inLoss) {
                if (now - lastShown >= REMIND_INTERVAL) {
                    lastShown = now;
                    setShowPopup(true);
                }
            } else {
                // Flag cleared (e.g. client topped up / margin healthy again):
                // hide the popup and reset the timer so a future loss re-shows it.
                lastShown = 0;
                setShowPopup(false);
            }
        };

        checkBalanceNotified();
        const interval = setInterval(checkBalanceNotified, 30 * 1000);

        return () => clearInterval(interval);
    }, [isAuthenticated]);
    const closePopup = () => setShowPopup(false);

    return (
        <NotificationContext.Provider value={{ showPopup, closePopup }}>
            {children}
        </NotificationContext.Provider>
    );
};
